import {HTTP_INTERCEPTORS} from '@angular/common/http';
import { IdenediAPIVersioningInterceptor } from './idenedi-api-versioning.interceptor';
import {HttpAuthInterceptor} from './http-auth.interceptor';
import {HttpCacheInterceptor} from './http-cache.interceptor';
import { PlannexeApiAuthInterceptor } from '@plannexe/shared/interceptor/plannexe-api-auth.interceptor';
import { SandboxInterceptor } from './sandbox.interceptor';

//import { TokenInterceptor } from '@plannexe/shared/interceptor/token.interceptor';

export { ChunkLoadErrorHandler } from './chunk-load-error.handler';

export const httpInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: IdenediAPIVersioningInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: HttpCacheInterceptor, multi: true},
  // Plannexe API tak jaane wali un requests ke liye jo lazy project.module ke
  // TokenInterceptor se nahi guzarteen (root-provided services) — sirf tab token
  // lagata ha jab request par pehle se Authorization na ho, aur sirf plannexe base URL par.
  {provide: HTTP_INTERCEPTORS, useClass: PlannexeApiAuthInterceptor, multi: true},
  {provide:  HTTP_INTERCEPTORS, useClass: SandboxInterceptor, multi: true},

  //{provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},

];
